<template>
  <div class="row">
    <div class="col-12 mb-4">
      <!-- Annual Gross Total Chart -->
      <Card cardClasses="shadow border-0 h-100 rounded-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div>
            <div class="d-flex align-items-center mb-2">
              <vue-feather type="dollar-sign" stroke="#6944a3" size="26"></vue-feather>
              <h3 class="mb-0 text-muted ms-2">{{ title }}</h3>
            </div>
          </div>
          <div class="chart-icon chart-icon-primary rounded-4 me-2 d-flex align-items-center justify-content-center">
            <vue-feather type="dollar-sign" stroke="#ffffff" size="18"></vue-feather>
          </div>
        </div>

        <!-- Display totals -->
        <div class="d-flex justify-content-evenly align-items-center mb-3">
          <div class="d-flex flex-wrap justify-content-center gap-3">
            <div class="total-card p-2 rounded-3 text-center" style="background-color: #89c8ee;">
              <div class="fw-bold text-black-50">Gross Income</div>
              <div class="font-size-125 fw-bolder text-black">{{ formatNumber(data.grossTotal) }}</div>
            </div>
            <div class="total-card p-2 rounded-3 text-center" style="background-color: #eea1ba;">
              <div class="fw-bold text-black-50">Statutory Deductions</div>
              <div class="font-size-125 fw-bolder text-black">{{ formatNumber(data.statutoryDeductionsTotal) }}</div>
            </div>
            <div class="total-card p-2 rounded-3 text-center" style="background-color: #f7c693;">
              <div class="fw-bold text-black-50">Other Deductions</div>
              <div class="font-size-125 fw-bolder text-black">{{ formatNumber(data.otherDeductionsTotal) }}</div>
            </div>
            <div class="total-card p-2 rounded-3 text-center" style="background-color: #f9dfa2;">
              <div class="fw-bold text-black-50">Net Income</div>
              <div class="font-size-125 fw-bolder text-black">{{ formatNumber(data.netTotal) }}</div>
            </div>
          </div>
        </div>
        <hr>

        <div class="chart-container p-2">
          <Bar
              style="max-height: 450px"
              id="my-chart-id"
              :options="chartOptions"
              :data="chartData"
          />
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
    import 'chart.js/auto';
    import {Bar} from "vue-chartjs";
    import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
    import formatNumber from "@/utils/formatNumber";

    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

    export default {
        name: "GrossBarChart",
        components: {Bar},

        props:{
            data:{
                type:Object,
                required:true,
            },
            title: {
              type:String,
              required: true
            }
        },
      data(){
          let delayed;
          return {
            chartOptions: {
              responsive: true,
              animation: {
                onComplete: () => {
                  delayed = true;
                },
                delay: (context) => {
                  let delay = 0;
                  if (context.type === 'data' && context.mode === 'default' && !delayed) {
                    delay = context.dataIndex * 300 + context.datasetIndex * 100;
                  }
                  return delay;
                },
              },
            },
          }
      },

      computed: {
        chartData() {
          return {
            labels: this.data.data.months,
            datasets: this.populateDataSet()
          }
        },
      },

      methods: {
        formatNumber,
        populateDataSet() {
          let results = [];
          this.data.data.grossDataset.forEach((element) => {
            let info = {
              label: element.label,
              data: element.data,
              backgroundColor: element.backgroundColor,
              borderColor: element.borderColor,
              borderWidth: 2
            }
            results.push(info)
          })
          return results
        }
      }
    }
</script>

<style scoped>

/* Card and general styles */
.card {
  transition: all 0.3s ease;
  border-radius: 1rem;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.1) !important;
}

.text-primary {
  color: #652aa3 !important;
}

/* Chart Icons */
.chart-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-icon-primary {
  background-color: #652aa3;
}

.chart-stat-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-stat-icon-primary {
  background-color: #652aa3;
}

.chart-container {
  border-radius: 0.5rem;
  background-color: rgba(0, 0, 0, 0.02);
}

.total-card {
  min-width: 230px;
  opacity: 70%;
  transition: all 0.3s ease;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.total-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

</style>
